/* global UAParser */
import res from 'res';
import UAParser from 'ua-parser-js';
import angularStore from 'angular-storage';

export default angular.module('eventix.common.services.visitorData', [angularStore])
    .factory('VisitorData', function(store) {

        // Some queryParams (e.g.: affiliate codes) should be persisted beyond their initial session.
        const persistentQueryParams = {
            queryData: 30 // days
        };

        function parseQuery(qstr) {
            var query = {};
            var a = _.compact(qstr.substr(1).split('&'));
            for (var i = 0; i < a.length; i++) {
                var b = a[i].split('=');
                query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
            }

            // Check for new params to save to localStorage
            let newPersistentQueryParams = {};
            _.forEach(persistentQueryParams, (duration, key) => {
                if(query[key] !== undefined) {
                    newPersistentQueryParams[key] = {
                        value: query[key],
                        expires: moment().add(duration, 'days').format('X')
                    };
                }
            });

            // Restore params from localStorage
            let persistedQueryParams = store.get('persistentQueryParams');
            if(persistedQueryParams) {
                let now = moment().format('X');
                _.forEach(_.keys(persistedQueryParams), key => {
                    if(persistedQueryParams[key].expires < now)
                        delete persistedQueryParams[key];
                });
                let addedParams = _.mapValues(persistedQueryParams, 'value');
                _.defaults(query, addedParams);
            }

            // Update localStorage
            store.set('persistentQueryParams', _.defaults(newPersistentQueryParams, persistedQueryParams));
            return query;
        }

        var parser = new UAParser();
        var visitorData = {
            screen: {
                width: window.screen.width,
                height: window.screen.height,
                orientation: {
                    angle: _.get(window.screen, 'orientation.angle'),
                    type: _.get(window.screen, 'orientation.type')
                },
                dpi: res.dpi(),
                dpcm: res.dpcm(),
                dppx: res.dppx()
            },
            userAgent: parser.getResult(),
            queryParams: parseQuery(document.location.search),
            timezone: moment.tz.guess(),
            adblock: false,
            referrer: document.referrer,
            doNotTrack: !!navigator.doNotTrack,
            cookieEnabled: navigator.cookieEnabled,
            visitorId: null
        };

        (function generateVisitorId() {
            function hex8() {
                return Math.floor((1 + Math.random()) * 0x100000000)
                    .toString(16)
                    .substring(1);
            }
            let vid = store.get('vid');
            if (!vid) {
                vid = hex8();
                store.set('vid', vid);
            }
            visitorData.visitorId = vid;
        })();

        (function adblockTest() {
            let img = document.createElement('img');
            $(img).on('error', function() {
                visitorData.adblock = true;
            });
            img.src = '/img/ads/banner.png';
        })();

        return visitorData;
    }).name;
